export async function syncToGoogleCalendar({commit}) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.calendar.sync();
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function callBackGoogle({commit}, payload) {
  commit('showPageLoading', payload, {root: true});
  const response = await this.$adminRepositories.calendar.callback(payload);
  commit('hidePageLoading', payload, {root: true});
  return response;
}

export async function checkTokenIsValid() {
  return this.$adminRepositories.calendar.checkTokenIsValid();
}
